module.exports = "../dist/frontend/images/white/carousel/account.svg?5251fef17ca3bca8e643e852be7de816";